// Entradas de Trackernet en marcha (sin timeEnd) de los tickets de una página del listado,
// en una sola petición. Un fallo no debe impedir ver el listado: se devuelve lo que haya.
export async function loadRunningTimeEntries(tickets, getEntries) {
  const ids = [...new Set((tickets || []).map(ticket => ticket.id))];
  if (!ids.length) return {};
  try {
    const response = await getEntries({ 'ticket.id': ids, 'exists[timeEnd]': false, itemsPerPage: 200 });
    const running = {};
    for (const entry of response?.data?.['hydra:member'] ?? []) {
      const ticketId = Number(String(entry.ticket?.['@id'] ?? entry.ticket ?? '').split('/').pop());
      if (ticketId && !running[ticketId]) running[ticketId] = entry;
    }
    return running;
  } catch {
    return {};
  }
}

// Tiempo ya imputado en Trackernet a los tickets de una página del listado ({ [ticketId]: segundos }),
// en una sola petición; un fallo no impide ver el listado
export async function loadTrackedTimes(tickets, getTotals) {
  const ids = [...new Set((tickets || []).map(ticket => ticket.id))];
  if (!ids.length) return {};
  try {
    const response = await getTotals(ids);
    return response?.data?.totals ?? {};
  } catch {
    return {};
  }
}

// "45m", "2h 05m": tiempo que lleva en marcha una entrada
export function formatElapsed(timeStart, now = Date.now()) {
  const start = new Date(timeStart).getTime();
  if (!Number.isFinite(start)) return '';
  const minutes = Math.max(0, Math.floor((now - start) / 60000));
  const hours = Math.floor(minutes / 60);
  return hours > 0 ? hours + 'h ' + String(minutes % 60).padStart(2, '0') + 'm' : minutes + 'm';
}

// Líneas con los datos de la entrada en marcha para el aviso de "hay una tarea en marcha"
export function describeRunningEntry(entry, currentTicket, now = Date.now()) {
  const started = new Date(entry.timeStart);
  const lines = [
    'Descripción: ' + (entry.description || '—'),
    'Proyecto: ' + (entry.project?.name || '—'),
    'Iniciada: ' + (Number.isNaN(started.getTime()) ? '—' : started.toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }))
      + ' (lleva ' + formatElapsed(entry.timeStart, now) + ')',
  ];
  const ticketIri = entry.ticket?.['@id'] ?? entry.ticket ?? null;
  if (!ticketIri) {
    lines.push('No corresponde a este ticket: no está asociada a ningún ticket.');
  } else if (ticketIri !== currentTicket?.['@id']) {
    lines.push('No corresponde a este ticket: pertenece al ticket ' + String(ticketIri).split('/').pop() + '.');
  }
  return lines;
}

// "<1m", "45m", "12h 05m": tiempo total imputado, en segundos
export function formatTracked(seconds) {
  const total = Number(seconds);
  if (!Number.isFinite(total) || total <= 0) return '';
  const minutes = Math.floor(total / 60);
  if (minutes < 1) return '<1m';
  const hours = Math.floor(minutes / 60);
  return hours > 0 ? hours + 'h ' + String(minutes % 60).padStart(2, '0') + 'm' : minutes + 'm';
}
